<template>
  <div>
    <p class="bread-crumb"><span>进货款管理</span><span class="fr" style="font-size: 14px;color: #4990E2;cursor: pointer"
    @click="showTips">进货款充值使用方法</span></p>
    <el-row class="data-card" :gutter="10">
      <el-col :span="8">
        <div class="card">
          <span>进货款余额</span>
          <div class="card-info">
            <span>{{accountInfo.inventoryAmount}}</span>
            <el-button type="text" class="button" size="small" @click="toRechargeList">查看充值申请</el-button>
          </div>
          <el-button type="primary" @click="doRecharge">充值</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="card">
          <span style="margin-right: 5px">返还金额</span>
          <el-button type="text" class="button" @click="goDefine" size="small">查看定义</el-button>
          <div class="card-info">
            <span>{{accountInfo.returnAmount}}</span>          
          </div>
          <el-button type="primary" @click="doWithdrawals">提现</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="card">
          <span>适用本规则的商品</span>
          <div class="card-info">
            <span>{{accountInfo.supportImprestAlbumCount}}</span> 
            <el-popover
              ref="popover1"
              placement="right"
              width="200"
              trigger="hover"
              content="部分商品因进货款余额不足，不能适用高分成比例">
              <a slot="reference"><i class="el-icon-warning"></i>仅部分商品适用</a>
              <!-- <el-button slot="reference">focus 激活</el-button> -->
            </el-popover>
          </div>
          <a class="el-button el-button--primary" 
            target="_blank"
            :href="`/imprest/export`">
            <span style="font-size: 12px" class="exportText">导出商品列表</span>
          </a>
        </div>
      </el-col>
    </el-row>
    <el-form class="search-form white-box" ref="form" :model="form" :inline="true" label-width="100px">
      <el-form-item label="交易编号">
        <el-input v-model="form.number" placeholder="请输入编号"></el-input>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input v-model="form.productName" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="交易时间">
        <el-date-picker v-model="form.time" type="datetimerange" placeholder="请选择时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="form.flowType" placeholder="请选择类型">
          <el-option label="全部" value="0"></el-option>
          <el-option label="充值" value="1"></el-option>
          <el-option label="用户购买" value="4"></el-option>
          <el-option label="用户退款" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="资金流向">
        <el-select v-model="form.inOrOut" placeholder="请选择资金流向">
          <el-option label="全部" value="0"></el-option>
          <el-option label="流入" value="1"></el-option>
          <el-option label="流出" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="余额变动类型">
        <el-select v-model="form.moneyFlowType" placeholder="请选择金额变动类型">
          <el-option label="全部" value="0"></el-option>
          <el-option label="进货款余额" value="1"></el-option>
          <el-option label="返还金额" value="2"></el-option>
        </el-select>
      </el-form-item>      
      <el-form-item>
      <el-button type="primary" @click="getAccountList()">搜索</el-button>
      </el-form-item>
    </el-form>
    <p class="table-name white-box">进货款交易明细</p>
    <el-table 
    :data="tableData" 
    class="search-table"
    stripe
    v-loading.body="loading">
      <el-table-column
        prop="number"
        label="编号"
        show-overflow-tooltip
        width="100">
      </el-table-column>
      <el-table-column
        prop="date"
        label="日期"
        width="180">
        <template scope="scope">
          {{moment(scope.row.date).format('YYYY-MM-DD HH:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        width="100">
      </el-table-column>
      <el-table-column
        prop="productName"
        label="商品"
        width="120">
      </el-table-column>
      <el-table-column
        prop="inventoryAmount"
        label="进货款余额变动"
        width="120">
      </el-table-column>
      <el-table-column
        prop="afterInventoryAmount"
        label="变动后金额"
        width="120">
      </el-table-column>
      <el-table-column
        prop="returnAmount"
        label="返还金额"
        width="120">
      </el-table-column>
      <el-table-column
        prop="afterReturnAmount"
        label="返还金额余额"
        width="120">
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template scope="scope">
          <el-button @click="toDetail(scope.row)" type="text" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="pageInfo.curPage"
      :page-size="pageInfo.pageSize"
      layout="total, prev, pager, next"
      :total="pageInfo.total">
    </el-pagination>
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="my-dialog">
      <p class="dialog-title" @click="closeCarousel">跳过</p>
      <my-carousel 
        trigger="click" 
        height="500px"
        :loop="false"
        arrow="always"
        :autoplay="false"
        indicator-position="outside"
        style="width: 680px">
        <el-carousel-item>
          <div class="carousel list-1"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel list-2"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel list-3"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel list-4"></div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="carousel list-5" >
            <div class="btn" @click="closeCarousel"></div>
          </div>
        </el-carousel-item>
      </my-carousel>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import moment from 'moment'
import {getAccountInfo, getAccountList} from 'api'
import myCarousel from 'components/carousel'
export default {
  data() {
    return {
      form: {
        number: '',
        flowType: '0',
        productName: '',
        moneyFlowType: '0',
        inOrOut: '0',
        time: ''
      },
      tableData: [],
      pageInfo: {
        pageSize: 20,
        total: 0,
        curPage: 1
      },
      accountInfo: {
        inventoryAmount: 0,
        returnAmount: 0,
        supportImprestAlbumCount: 0
      },
      dialogVisible: false,
      loading: true
    }
  },
  components: {
    myCarousel
  },
  computed: {
    moment () {
      return moment
    }
  },
  methods: {
    doRecharge () {
      this.$router.push('/advancepayment/recharge')
    },
    doDownload () {
      downLoadAccountList({...this.requestParams})
    },
    doWithdrawals () {   //提现
      this.$alert('功能即将上线，请耐心等待', '标题名称', {
        confirmButtonText: '确定'
      })
    },
    goDefine () {       //返还金额查看定义
      window.open('https://shimo.im/docs/e6iyTBgPb8cg1ezx/', '_blank')
    },
    showTips () {       //货款充值使用方法
      // this.$data.dialogVisible = true
      window.open('https://shimo.im/docs/wKWIR0wZIcYrqFqY/', '_blank')
    },
    toDetail (row) {    //查看详情
      // 2 跳转到站外订单列表页
      // 1 跳转到合伙人申请记录列表页
      row.source == 2 ? this.$router.push({path:'/ordermanager/index', query: {number: row.number}}): this.$router.push({path: '/advancepayment/rechargeList', query: {number: row.number}})
    },
    toRechargeList () {
      this.$router.push('/advancepayment/rechargelist')
    },
    handleCurrentChange (item) {  //翻页
      // this.$data.pageInfo.curPage = item
      this.getAccountList(item)
    },
    getAccountList(page) {    //获取货款信息列表
      const _form = this.$data.form 
      const requestParams = Object.assign({}, _form)
      this.requestParams = requestParams
      if (requestParams.time && requestParams.time.length) {
        requestParams.from = requestParams.time[0] ? moment(requestParams.time[0]).format('YYYY-MM-DD HH:mm:ss') : ''
        requestParams.to = requestParams.time[1] ? moment(requestParams.time[1]).format('YYYY-MM-DD HH:mm:ss') : ''
      } else {
        requestParams.from = ''
        requestParams.to = ''
      }
      requestParams.curPage = page || 1 //this.$data.pageInfo.curPage
      delete requestParams.time
      
      // 下载地址拼接
      // let downLoadPath = ''
      // for(let item in requestParams) {
      //   if(item != 'curPage') {
      //     downLoadPath = downLoadPath ? downLoadPath + '&' + item + '=' + requestParams[item]: item + '=' + requestParams[item]
      //   }        
      // }
      // this.downLoadPath = downLoadPath

      const _me = this
      _me.$data.loading = true
      getAccountList({...requestParams}).then(res => {
        _me.$data.loading = false
        if (res.ret == 0) {
          _me.$data.tableData = res.data.list
          _me.$data.pageInfo.total = res.data.totalRecords
          _me.$data.pageInfo.pageSize = res.data.pageSize
          _me.$data.pageInfo.curPage = res.data.curPage
        }
      }).catch( error => {
        _me.$data.loading = false
      })
    },
    closeCarousel () {
      this.$data.dialogVisible = false
    }
  },
  created () {
    const _me = this
    getAccountInfo({}).then(res => {
      if (res.ret == 0) {
        _me.$data.accountInfo.returnAmount = res.data.returnAmount
        _me.$data.accountInfo.inventoryAmount = res.data.inventoryAmount
        _me.$data.accountInfo.supportImprestAlbumCount = res.data.supportImprestAlbumCount
        if (res.data.first) { //用户是否第一次进入预付款页面展示轮播图
          _me.$data.dialogVisible = true;
        }
      } else {
        console.log('数据请求出错')
      }
    })
    this.getAccountList()
  }
}
</script>
<style type="text/css">
.page-container .bread-crumb {
  height: 40px;
  padding: 0 20px;
  background-color: #fff;
  line-height: 40px;
  margin-bottom: 10px;
  font-size: 20px;
  color: #333;
}
.fr {
  float: left;
}
.el-dialog .el-dialog__header {
    padding: 0;
}
.el-loading-mask {
  z-index: 1000 !important;
} 
.my-dialog .el-dialog--small {
  width: 720px;
}
</style>
<style lang="scss" scoped>
.data-card {
  // font-family: 'MicrosoftYaHei';
  margin-bottom: 10px;
  .card {
    padding: 30px;
    height: 200px;
    .card-info {
      height: 70px;
      line-height: 70px;   
      span {
        font-size: 24px;
        color: #F59D00;
      }
      a {
        margin-left: 20px;
        font-size: 12px;
        color: #999;
      }
    }
  }
}
.el-select, .el-input{
  width: 170px;
}
.table-name {
  font-size: 14px;
  color: #333;
  line-height: 50px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}
.search-form {
  padding: 20px;
  margin-bottom: 5px;
}
.search-table {
  margin-bottom: 5px;
  width: 100%;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.carousel {
   height: 500px;
   background-size: 680px;
   background-repeat: no-repeat;
   background-color: #fff;
}
.list-1 {
  background-image: url('../../assets/carousel-image/1@2x.jpg');
}
.list-2 {
  background-image: url('../../assets/carousel-image/2@2x.jpg');
}
.list-3 {
  background-image: url('../../assets/carousel-image/3@2x.jpg');
}
.list-4 {
  background-image: url('../../assets/carousel-image/4@2x.jpg');
}
.list-5 {
  background-image: url('../../assets/carousel-image/5@2x.jpg'); 
  .btn {
    cursor: pointer;
    width: 100px;
    height: 50px;
    background-color: rgba(255, 255, 255, 0);
    position: absolute;
    bottom: 40px;
    left: 270px;
  }
}

table .el-button--text {
  color: #f86442;
}
.dialog-title {
  text-align: right;
  color: #4990E2;
  cursor: pointer
}
</style>


// WEBPACK FOOTER //
// index.vue?09d1203f